import React, { FC, ReactNode } from 'react';
import { IClassNameProps } from '@bem-react/core';
import { Link } from '@yandex-int/hr-components/Link/bundle';
import { cn as classname } from '@bem-react/classname';
import './PopupAction.css';


export interface PopupActionProps extends IClassNameProps {
    text: string;
    icon: ReactNode;
    onClick?: () => void;
    onlyIcon?: boolean;
    url?: string;
}

export const PopupAction: FC<PopupActionProps> = props => {
    const { text, onClick, icon, onlyIcon, url, className } = props;
    const cn = classname('PopupAction');

    return (
        <Link
            className={cn('Action', { onlyIcon }, [className])}
            target="_blank"
            onClick={onClick}
            title={text}
            href={url}
        >
            {icon}
            {onlyIcon ? null : <span>{text}</span>}
        </Link>
    );
};
